import { loggedIn } from '@/router/middlewares';

export default [
  {
    path: '',
    name: 'apps',
    props: true,
    meta: {
      middleware: [loggedIn]
    },
    component: () => import(/* webpackChunkName: "apps" */ './page.vue'),
    children: [
      {
        path: ':id',
        name: 'appsTableComponent',
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "appTableComponent" */ './item/index.vue'
          ),
        meta: {
          rootRouteName: 'apps'
        }
      },
      {
        path: ':id/:nestedId',
        name: 'appsNestedComponent',
        props: true,
        component: () =>
          import(/* webpackChunkName: "appTableComponent" */ './item/index.vue')
      }
    ]
  },
  {
    path: '',
    redirect: { name: 'apps' }
  }
];
